/* eslint react/no-danger: 0 */
import React from 'react';
import PaymentsStore from '../../stores/PaymentsStore';
import MemberStore from '../../stores/MemberStore';
import MembersBlockItem from '../member/MembersBlockItem';

const PaymentsTitle = () => {
  const title = PaymentsStore.getTitle();
  if (!title.length) {
    return null;
  }

  const type = PaymentsStore.getType();
  const member = PaymentsStore.getSubscriptionMember();

  if (type !== 'subscription_other' || !member) {
    return (
      <div
        className="paymentContainer-title mbxs mts"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  }

  MemberStore.addMember(member);

  return (
    <div className="row mbm">
      <div className="paymentContainer-header dib group">
        <div className="paymentContainer-member fl mrm">
          <MembersBlockItem
            member={member}
            imageType="xm"
            customLinkClass="member member--xm"
            hideAnswerScore
            hideAge
            hideLocation
            hideMenu
            hideIcons
            hideVerificationBadge
          />
        </div>
        <div
          className="paymentContainer-title paymentContainer-title--small fl tal"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </div>
  );
};

export default PaymentsTitle;
